module.exports = __webpack_public_path__ + "static/media/planning-for-success.b8b98e30.png";